<template>
  <div id="original-bar"></div>
</template>
 
<script>
import * as echarts from 'echarts'
export default {
    props:{
      newArray:{
          type:Object,
          required:true,
          value:()=>{}
      }
    },
       name:'originCompoment',
       data(){ 
       return{
        myChart:null
       }
    },
    watch:{
       newArray:{
           handler(newValue,oldValue){
              if(this.myChart){
                 if(newValue){
                      var option = this.myChart.getOption()
                    option.xAxis[0].data= newValue.totalList
                    option.series = newValue.seriesList
                    this.myChart.setOption(option)
                 }else{
                      var option = this.myChart.getOption()
                    option.xAxis[0].data= oldValue.totalList
                    option.series = oldValue.seriesList
                    this.myChart.setOption(option)
                 }
              }else{
                this.renderInit()
              }
           },
           deep:true
       }
    },
   mounted() {
         this.renderInit()
   },
   methods: {
       renderInit(){
              this.myChart = echarts.getInstanceByDom(document.getElementById('original-bar'));
              if(!this.myChart){
                this.myChart = echarts.init(document.getElementById('original-bar'));
            }
         var option = {
                 title:{
                        left: '1%',
                        top:'-1%',
                        text: '电表值',
                         textStyle:{
                            fontWeight:'400',
                            fontSize:'15'
                        }
                    },
                      tooltip: {
                        trigger: 'axis'
                    },
                   grid: {
                        top:'10%',
                        left:'4%',
                        right:'4%',
                        bottom: '10%'
                    },
                    xAxis: {
                        type: 'category',
                        data: this.newArray.totalList,
                        axisTick:{
                            show:false
                        },
                        axisPointer: {
                            type: 'shadow'
                        },
                        axisLine:{
                            show:true,
                        lineStyle:{
                                color:'#f3f3f3'
                                }
                            },
                        axisLabel:{
                            color:'#333',
                            alignWithLabel: true
                        }
                    },
                    yAxis: {
                        type: 'value',
                        splitLine:{
                        lineStyle:{
                            color:'#f3f3f3'
                            }
                        }
                    },
                    series: this.newArray.seriesList
                };
              let myChart = this.myChart
             myChart.setOption(option);
              //根据窗口的大小变动图表 --- 重点
                setTimeout( ()=>{
              window.addEventListener("resize", () => { myChart.resize(); })
	        },200)
       }
   

   },
}
</script>
 
<style lang='less' scoped>
 #original-bar{
     width: 100%;
     height: 100%;
 }
</style>